var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("adjustInventory"),
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("confirm"),
      hasAlert: "",
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { "align-end": "", "justify-start": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "required_field",
                      attrs: {
                        items: _vm.warehousesSites,
                        "item-text": "siteName",
                        "return-object": "",
                        label: _vm.$t("warehouseSite"),
                        rules: [_vm.fieldIsRequired("Warehouse site")]
                      },
                      model: {
                        value: _vm.warehouseSite,
                        callback: function($$v) {
                          _vm.warehouseSite = $$v
                        },
                        expression: "warehouseSite"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { md1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("permissionCode"),
                        rules: [
                          function(v) {
                            return (
                              v === "20200125" || _vm.$t("wrongPermissionCode")
                            )
                          }
                        ]
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "required_field",
                      attrs: {
                        items: _vm.organizations,
                        "item-text": "displayName",
                        "return-object": "",
                        label: _vm.$t("from"),
                        rules: [_vm.fieldIsRequired("Organization")]
                      },
                      model: {
                        value: _vm.from,
                        callback: function($$v) {
                          _vm.from = $$v
                        },
                        expression: "from"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { md1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "required_field",
                      attrs: {
                        items: _vm.organizations,
                        "item-text": "displayName",
                        "return-object": "",
                        label: _vm.$t("to"),
                        rules: [_vm.fieldIsRequired("Organization")]
                      },
                      model: {
                        value: _vm.to,
                        callback: function($$v) {
                          _vm.to = $$v
                        },
                        expression: "to"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { "align-end": "", "justify-start": "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: { label: _vm.$t("upc") },
                      model: {
                        value: _vm.upc,
                        callback: function($$v) {
                          _vm.upc = $$v
                        },
                        expression: "upc"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { attrs: { md1: "" } }),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { md3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "required_field",
                      attrs: {
                        label: _vm.$t("quantity"),
                        rules: [
                          _vm.fieldIsNumber(),
                          _vm.fieldIsNoLessThanZero()
                        ]
                      },
                      model: {
                        value: _vm.quantity,
                        callback: function($$v) {
                          _vm.quantity = _vm._n($$v)
                        },
                        expression: "quantity"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-textarea", {
              attrs: { id: "balance_note", label: _vm.$t("note"), outline: "" },
              model: {
                value: _vm.note,
                callback: function($$v) {
                  _vm.note = $$v
                },
                expression: "note"
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dbd8c7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbd8c7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseAdjustInventory.vue
// module id = null
// module chunks = 